const HtmlUtils = {
  generateComponentId(prepend = 'comp') {
    return (
      prepend +
      HtmlUtils.randomString() +
      HtmlUtils.randomString() +
      HtmlUtils.randomString() +
      HtmlUtils.randomString()
    );
  },
  randomString() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  },
};

export default HtmlUtils;
